import { ChainID } from '@jdiyield/constants'
import { Contract, PriceList, Stake, Token } from '@jdiyield/interfaces'
// import MasterChefPancakeBunny from '../../../smc/contracts/MasterChefPancakeBunny.json'
import BigNumber from 'bignumber.js'
import Web3 from 'web3'

import { calculate } from '../calculate'
import getNodeUrl from '../rpcRandom'
import { StakeFunc, StakeProps } from '../types'
import { findToken, makeBatchRequest, safeGasEstimates } from '../utils'

const BSCDashBoardAbi = [
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'previousOwner', type: 'address' },
      { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    inputs: [],
    name: 'BANANA',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'SPACE',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'VaultBanana',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'WBNB',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'apeswapPoolIds',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'address', name: 'account', type: 'address' }
    ],
    name: 'calculateProfit',
    outputs: [
      { internalType: 'uint256', name: 'profit', type: 'uint256' },
      { internalType: 'uint256', name: 'profitInBNB', type: 'uint256' }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'address', name: 'account', type: 'address' }
    ],
    name: 'infoOfPool',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'pool', type: 'address' },
          { internalType: 'uint256', name: 'balance', type: 'uint256' },
          { internalType: 'uint256', name: 'principal', type: 'uint256' },
          { internalType: 'uint256', name: 'available', type: 'uint256' },
          { internalType: 'uint256', name: 'tvl', type: 'uint256' },
          { internalType: 'uint256', name: 'utilized', type: 'uint256' },
          { internalType: 'uint256', name: 'liquidity', type: 'uint256' },
          { internalType: 'uint256', name: 'pBASE', type: 'uint256' },
          { internalType: 'uint256', name: 'pSPACE', type: 'uint256' },
          { internalType: 'uint256', name: 'depositedAt', type: 'uint256' },
          { internalType: 'uint256', name: 'feeDuration', type: 'uint256' },
          { internalType: 'uint256', name: 'feePercentage', type: 'uint256' }
        ],
        internalType: 'struct PoolConstant.PoolInfoBSC',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'perfExemptions',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'pool', type: 'address' }],
    name: 'poolTypeOf',
    outputs: [{ internalType: 'enum PoolConstant.PoolTypes', name: '', type: 'uint8' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'poolTypes',
    outputs: [{ internalType: 'enum PoolConstant.PoolTypes', name: '', type: 'uint8' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address[]', name: 'pools', type: 'address[]' }
    ],
    name: 'poolsOf',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'pool', type: 'address' },
          { internalType: 'uint256', name: 'balance', type: 'uint256' },
          { internalType: 'uint256', name: 'principal', type: 'uint256' },
          { internalType: 'uint256', name: 'available', type: 'uint256' },
          { internalType: 'uint256', name: 'tvl', type: 'uint256' },
          { internalType: 'uint256', name: 'utilized', type: 'uint256' },
          { internalType: 'uint256', name: 'liquidity', type: 'uint256' },
          { internalType: 'uint256', name: 'pBASE', type: 'uint256' },
          { internalType: 'uint256', name: 'pSPACE', type: 'uint256' },
          { internalType: 'uint256', name: 'depositedAt', type: 'uint256' },
          { internalType: 'uint256', name: 'feeDuration', type: 'uint256' },
          { internalType: 'uint256', name: 'feePercentage', type: 'uint256' }
        ],
        internalType: 'struct PoolConstant.PoolInfoBSC[]',
        name: '',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address[]', name: 'pools', type: 'address[]' }
    ],
    name: 'portfolioOf',
    outputs: [{ internalType: 'uint256', name: 'deposits', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'priceCalculator',
    outputs: [{ internalType: 'contract PriceCalculator', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'address', name: 'account', type: 'address' }
    ],
    name: 'profitOfPool',
    outputs: [
      { internalType: 'uint256', name: 'profit', type: 'uint256' },
      { internalType: 'uint256', name: 'space', type: 'uint256' }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  { inputs: [], name: 'renounceOwnership', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'uint256', name: 'pid', type: 'uint256' }
    ],
    name: 'setApeswapPoolId',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'bool', name: 'exemption', type: 'bool' }
    ],
    name: 'setPerfExemption',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'pool', type: 'address' },
      { internalType: 'enum PoolConstant.PoolTypes', name: 'poolType', type: 'uint8' }
    ],
    name: 'setPoolType',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'pool', type: 'address' }],
    name: 'tvlOfPool',
    outputs: [{ internalType: 'uint256', name: 'tvl', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'pool', type: 'address' }],
    name: 'utilizationOfPool',
    outputs: [
      { internalType: 'uint256', name: 'liquidity', type: 'uint256' },
      { internalType: 'uint256', name: 'utilized', type: 'uint256' }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

const VaultAbi = [
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' }
    ],
    name: 'Deposited',
    type: 'event'
  },
  { anonymous: false, inputs: [], name: 'DisableWhitelist', type: 'event' },
  { anonymous: false, inputs: [], name: 'EnableWhitelist', type: 'event' },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: 'uint256', name: 'profit', type: 'uint256' }],
    name: 'Harvested',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'profit', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'performanceFee', type: 'uint256' }
    ],
    name: 'MerlinPaid',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'previousOwner', type: 'address' },
      { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: 'bool', name: 'isPaused', type: 'bool' }],
    name: 'PauseChanged',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'profit', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'performanceFee', type: 'uint256' }
    ],
    name: 'ProfitPaid',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: 'address', name: 'token', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' }
    ],
    name: 'Recovered',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: '_address', type: 'address' },
      { indexed: false, internalType: 'bool', name: 'whitelist', type: 'bool' }
    ],
    name: 'Whitelisted',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'withdrawalFee', type: 'uint256' }
    ],
    name: 'Withdrawn',
    type: 'event'
  },
  {
    inputs: [],
    name: 'balance',
    outputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'cakeHarvested',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'uint256', name: '_amount', type: 'uint256' }],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  { inputs: [], name: 'depositAll', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'depositedAt',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'bool', name: 'disable', type: 'bool' }],
    name: 'disableWhitelist',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'earned',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  { inputs: [], name: 'getReward', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  { inputs: [], name: 'harvest', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [
      { internalType: 'uint256', name: '_pid', type: 'uint256' },
      { internalType: 'address', name: '_token', type: 'address' },
      { internalType: 'address', name: '_merlin', type: 'address' },
      { internalType: 'address', name: '_cake', type: 'address' },
      { internalType: 'address', name: '_wbnb', type: 'address' },
      { internalType: 'address', name: '_masterchef', type: 'address' },
      { internalType: 'address', name: '_zap', type: 'address' }
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: '_address', type: 'address' }],
    name: 'isWhitelist',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'keeper',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'lastPauseTime',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' }
    ],
    name: 'migrate',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
    name: 'migrateToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'minter',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'paused',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'pid',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'poolType',
    outputs: [{ internalType: 'enum PoolConstant.PoolTypes', name: '', type: 'uint8' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'priceShare',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'principalOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' }
    ],
    name: 'recoverToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  { inputs: [], name: 'renounceOwnership', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [],
    name: 'rewardsToken',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: '_keeper', type: 'address' }],
    name: 'setKeeper',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'newMinter', type: 'address' }],
    name: 'setMinter',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'bool', name: '_paused', type: 'bool' }],
    name: 'setPaused',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_pid', type: 'uint256' },
      { internalType: 'address', name: 'token', type: 'address' }
    ],
    name: 'setPidToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: '_address', type: 'address' },
      { internalType: 'bool', name: '_on', type: 'bool' }
    ],
    name: 'setWhitelist',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'sharesOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'stakingToken',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalShares',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'uint256', name: 'shares', type: 'uint256' }],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  { inputs: [], name: 'withdrawAll', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [{ internalType: 'uint256', name: '_amount', type: 'uint256' }],
    name: 'withdrawUnderlying',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'withdrawableBalanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  }
]

const PriceAbi = [
  {
    inputs: [
      { internalType: 'address', name: '_SPACE_TOKEN', type: 'address' },
      { internalType: 'address', name: '_SPACE_BNB', type: 'address' },
      { internalType: 'contract IPriceOracle', name: '_oracle', type: 'address' }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'previousOwner', type: 'address' },
      { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    inputs: [],
    name: 'BANANA',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'BUSD',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'SPACE',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'SPACE_BNB',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'WBNB',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'asset', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' }
    ],
    name: '_oracleValueOf',
    outputs: [
      { internalType: 'uint256', name: 'valueInBNB', type: 'uint256' },
      { internalType: 'uint256', name: 'valueInUSD', type: 'uint256' }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'asset', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' }
    ],
    name: '_valueOfAsset',
    outputs: [
      { internalType: 'uint256', name: 'valueInBNB', type: 'uint256' },
      { internalType: 'uint256', name: 'valueInUSD', type: 'uint256' }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'oracle',
    outputs: [{ internalType: 'contract IPriceOracle', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'priceOfBNB',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'priceOfBanana',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'priceOfSpace',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address[]', name: 'assets', type: 'address[]' }],
    name: 'pricesInUSD',
    outputs: [{ internalType: 'uint256[]', name: '', type: 'uint256[]' }],
    stateMutability: 'view',
    type: 'function'
  },
  { inputs: [], name: 'renounceOwnership', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [
      { internalType: 'address', name: 'asset', type: 'address' },
      { internalType: 'bool', name: 'available', type: 'bool' }
    ],
    name: 'setOracleFeeds',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'asset', type: 'address' },
      { internalType: 'address', name: 'pairToken', type: 'address' }
    ],
    name: 'setPairToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'asset', type: 'address' },
      { internalType: 'address', name: 'feed', type: 'address' }
    ],
    name: 'setTokenFeed',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [{ internalType: 'address', name: 'newOracle', type: 'address' }],
    name: 'updateOracle',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      { internalType: 'address', name: 'asset', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' }
    ],
    name: 'valueOfAsset',
    outputs: [
      { internalType: 'uint256', name: 'valueInBNB', type: 'uint256' },
      { internalType: 'uint256', name: 'valueInUSD', type: 'uint256' }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

type PoolType = 'TOKEN' | 'LP'

export interface FarmConfig {
  pid: number
  lpSymbol?: string
  pool?: PoolType
  lpAddresses?: string
  tokenSymbol?: string
  tokenAddresses?: string
  quoteTokenAdresses?: string
  multiplier?: string
  isCommunity?: boolean
  earn?: string
  rewardSymbol?: string
  dual?: {
    rewardPerBlock: number
    earnLabel: string
    endBlock: number
  }
}

// interface Address {
//   97?: string
//   56: string
// }

// const wbnb = {
//   97: '0x0359001070cf696d5993e0697335157a6f7db289',
//   56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'
// }

// const BANANA = {
//   56: '0x603c7f932ed1fc6575303d8fb018fdcbb0f39a95',
//   137: '0x5d47baba0d66083c52009271faf3f50dcc01023c'
// }

const SPACE = {
  56: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
  137: '0xd016caae879c42cb0d74bb1a265021bf980a7e96'
}

const aperocketPriceCalculator = {
  56: '0x5D6086f8aae9DaEBAC5674E8F3b867D5743171D3',
  137: '0x9f7b203376d8Cebc7B8c16952dcd38377A3C1c19'
}

const farms: Record<number, FarmConfig[]> = {
  56: [
    // {
    //   pid: 0,
    //   lpSymbol: 'SPACE',
    //   pool: 'TOKEN',
    //   lpAddresses: '0xd79dc49Ed716832658ec28FE93dd733e0DFB8d58',
    //   tokenSymbol: 'SPACE',
    //   tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
    //   earn: 'WBNB',
    //   quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'
    // },
    {
      pid: 1,
      lpSymbol: 'BANANA Maximizer',
      pool: 'TOKEN',
      lpAddresses: '0xB8FDa49A709E9D00274053D9Ed34CCa1B4BB21f8',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BANANA+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'BANANA'
    },
    {
      pid: 2,
      lpSymbol: 'BANANA-BNB LP Maximizer',
      pool: 'LP',
      lpAddresses: '0x2A3980860C3B2caeadE5272DF66782297032fa5F',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BANANA+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'BANANA'
    },
    {
      pid: 3,
      lpSymbol: 'BANANA-BUSD LP Maximizer',
      pool: 'LP',
      lpAddresses: '0xEe6826Eb76f25994984687F2F38B1787eA3567C1',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BANANA+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'BANANA-BUSD'
    },
    {
      pid: 4,
      lpSymbol: 'BUSD-BNB LP Maximizer',
      pool: 'LP',
      lpAddresses: '0xC9E5b25d37cBcb30FC7aA11cE44E4652A319DdB2',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BANANA+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'BUSD-BNB'
    },
    {
      pid: 5,
      lpSymbol: 'BUSD-USDC LP Maximizer',
      pool: 'LP',
      lpAddresses: '0xdc8b4ABB0053e8443b964fb4c0680b55E21ca87d',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BANANA+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'BUSD-USDC'
    },
    {
      pid: 6,
      lpSymbol: 'ETH-BNB LP Maximizer',
      pool: 'LP',
      lpAddresses: '0x542618f90F2CA668D12d53b50B5008C2b3Acece7',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BANANA+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'ETH-BNB'
    },
    {
      pid: 7,
      lpSymbol: 'BANANA-BUSD LP',
      pool: 'LP',
      lpAddresses: '0x9d82Bb1983409bf79E599019F948EC36A3Bb05aD',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BANANA-BUSD+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'BANANA-BUSD'
    },
    {
      pid: 8,
      lpSymbol: 'BANANA-BNB LP',
      pool: 'LP',
      lpAddresses: '0xAd1E51D935D6d25B6483F6846b5bbBc1e20df3ef',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BANANA-BNB+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'BANANA-BNB'
    },
    {
      pid: 9,
      lpSymbol: 'BUSD-BNB LP',
      pool: 'LP',
      lpAddresses: '0xe927c82E2Ec5C2e045D58145854B8Fad48a3283A',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BUSD-BNB+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'BUSD-BNB'
    },
    {
      pid: 10,
      lpSymbol: 'BUSD-USDC LP',
      pool: 'LP',
      lpAddresses: '0xEAbbE6225F82655032ff049dfA461785a1965543',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BUSD-USDC+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'BUSD-USDC'
    },
    {
      pid: 11,
      lpSymbol: 'ETH-BNB LP',
      pool: 'LP',
      lpAddresses: '0x9a9d0374E05589C3F0b5C27B32119800a2e295cA',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'ETH-BNB+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'ETH-BNB'
    },
    {
      pid: 12,
      lpSymbol: 'BANANA-BNB LP Flip',
      pool: 'LP',
      lpAddresses: '0x5f7faeFC9606FfE8B519DDC2Acf3A12e5767a7EE',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BANANA+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'BANANA-BNB'
    },
    {
      pid: 13,
      lpSymbol: 'BANANA-BNB LP Flip',
      pool: 'LP',
      lpAddresses: '0x858CD232B2236da873f8F72518a6deD3eBa7F1aF',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BANANA+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'BANANA-BNB'
    },
    {
      pid: 14,
      lpSymbol: 'BUSD-BNB LP Flip',
      pool: 'LP',
      lpAddresses: '0xd0177E5Bde32765d1493D80f9b343a4E52010F5D',
      tokenSymbol: 'SPACE',
      tokenAddresses: '0xe486a69E432Fdc29622bF00315f6b34C99b45e80',
      earn: 'BANANA+SPACE',
      quoteTokenAdresses: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      rewardSymbol: 'BUSD-BNB'
    }
  ],
  137: [
    {
      pid: 999,
      lpAddresses: '0x0F3D1A56ad59ba1be2f290e91ae2b8E70cd20d42',
      rewardSymbol: 'pSPACE'
    },
    {
      pid: 0,
      lpAddresses: '0xCAb27557316B4CF1950872d54Cf853646e70B19D',
      rewardSymbol: 'WMATIC-BANANA'
    },
    {
      pid: 1,
      lpAddresses: '0xCF1AC4Aac55DA77854479c4069F7Fb25F290A93f',
      rewardSymbol: 'WMATIC-WETH'
    },
    {
      pid: 2,
      lpAddresses: '0xb2ce974aF77A8EcDF8f9E8BACF1A43f733D040FF',
      rewardSymbol: 'WMATIC-DAI'
    },
    {
      pid: 6,
      lpAddresses: '0x6F402Ce7Fd7d86946B6bc682341b9E4E225d3991',
      rewardSymbol: 'WMATIC-BNB'
    }
  ]
}

const aperoketChefAddress = {
  56: '0xe64AA77B1719eFf35D6740cB99200a193B8d6c97',
  137: '0xec171745131b88977f016f5fd7efc1eef00daa55'
}
const routerAddress = '0xC0788A3aD43d79aa53B09c2EaCc313A787d1d607'
// const BunnyDashboard = '0x59a5f2e3ebc4e47d482d6542244f5398fa8ce8d3'

export const getFarmsApeRocket = async (
  walletAddress: string,
  contract: Contract,
  chainID: ChainID,
  tokens: Token[],
  priceList: PriceList,
  web3Prop: Web3
): Promise<Stake> => {
  try {
    const web3 = web3Prop || new Web3(getNodeUrl(chainID))
    const myAccount = walletAddress
    const lookPrice = priceList
    // const price = lookPrice[jdi].usd
    try {
      const ct = new web3.eth.Contract(BSCDashBoardAbi as any, aperoketChefAddress[chainID])
      const stakingContract = new web3.eth.Contract(VaultAbi as any, contract.contractAddress)
      const [poolsOfCalls, stakingToken] = await makeBatchRequest(web3, [
        ct.methods.poolsOf(myAccount, [contract.contractAddress]).call,
        stakingContract.methods.stakingToken().call
      ])
      const poolsOf = {}
      if (poolsOfCalls) {
        poolsOfCalls.forEach((p) => {
          poolsOf[p.pool.toLowerCase()] = p
        })
      }

      const { balance } = poolsOf[contract.contractAddress.toLowerCase()]
      if (!balance || balance === '0') {
        return null
      }

      let { pBASE, pSPACE } = poolsOf[contract.contractAddress.toLowerCase()]
      if (!+pBASE && !+pSPACE) {
        pBASE = await stakingContract.methods.earned(myAccount).call()
        pSPACE = (pBASE * 30) / 100
      }

      const pid = farms[chainID].find((farm) => farm.lpAddresses === contract.contractAddress)?.pid

      const deposit = await calculate(
        web3,
        {
          pool: pid,
          lpAddress: stakingToken,
          balance: balance.toString(),
          availableBalanceOf: '0',
          rewardAddress: contract.rewardAddress
        },
        routerAddress,
        tokens,
        priceList
      )

      let pendingBASE = 0
      let pendingSPACE = 0

      if (+balance > 0) {
        pendingBASE = +pBASE / 1e18
        pendingSPACE = +pSPACE / 1e18
      }

      let rewardSecondary, rewardSymbolSecondary

      if (contract.rewardAddress !== SPACE[chainID]) {
        rewardSecondary = pendingSPACE
        rewardSymbolSecondary = findToken(tokens, SPACE[chainID])?.symbol ?? 'SPACE'
      }

      const basePrice = await getBasePrice(web3, chainID, contract.rewardAddress, pBASE, lookPrice)
      const spacePrice = lookPrice[SPACE[chainID]]?.usd || 0
      const rewardUSD = pendingBASE * basePrice + pendingSPACE * spacePrice
      const rewardSymbol =
        farms[chainID].find((farm) => farm.lpAddresses === contract.contractAddress)?.rewardSymbol ?? 'APE-LP'

      return {
        ...deposit,
        ...contract,
        // pool: pid,
        balance: new BigNumber(balance).dividedBy(1e18).toString(),
        lpAddress: stakingToken,
        // availableBalanceOf: new BigNumber(availableBalanceOf).dividedBy(1e18).toString(),
        availableBalanceOf: '0',
        reward: pendingBASE, /// TO DO: Implement
        rewardSecondary,
        rewardSymbol,
        rewardSymbolSecondary,
        rewardUSD
      }
    } catch (e) {
      console.log('getFarmsApeRocket', contract.contractAddress, e)
      return null
    }
  } catch (e) {
    console.log(e)
    return null
  }
}

const getBasePrice = async (web3, chainID: ChainID, rewardAddress: string, amount: string, priceList: PriceList) => {
  const priceContract = new web3.eth.Contract(PriceAbi as any, aperocketPriceCalculator[chainID])
  if (priceList[rewardAddress]?.usd) {
    return priceList[rewardAddress].usd
  } else {
    const result = await priceContract.methods.valueOfAsset(rewardAddress, amount).call()
    return result?.valueInUSD / 1e18 || 0
  }
}

export const stakeApeRocket: StakeFunc = async ({ web3, contractAddress, walletAddress, amount }) => {
  try {
    const ct = new web3.eth.Contract(VaultAbi as any, contractAddress)
    const contractWithMethod = ct.methods.deposit(new BigNumber(amount).times(new BigNumber(10).pow(18)).toFixed())
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })
  } catch (e) {
    console.log(e)
    return false
  }
}

export const unStakeApeRocket: StakeFunc = async ({ web3, contractAddress, walletAddress, amount }) => {
  try {
    const ct = new web3.eth.Contract(VaultAbi as any, contractAddress)
    const contractWithMethod = ct.methods.withdrawUnderlying(
      new BigNumber(amount).times(new BigNumber(10).pow(18)).toFixed()
    )
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })

    return true
  } catch (e) {
    return false
  }
}

export const getRewardApeRocket: StakeFunc<Omit<StakeProps, 'amount'>> = async ({
  web3,
  contractAddress,
  walletAddress
}) => {
  try {
    const ct = new web3.eth.Contract(VaultAbi as any, contractAddress)
    const contractWithMethod = ct.methods.getReward()
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })
    return true
  } catch (e) {
    return false
  }
}
